<div class="nav-notification-wrapper" (click)="onToggleNotifications()">
  <div class="bell">
    <app-svg-loader height="22px" url="assets/svg/bell-outline.svg"></app-svg-loader>
    <div class="bubble" *ngIf="unreadCount > 0"> {{ unreadCount > 99 ? '99+' : unreadCount }}</div>
  </div>

  <div [hidden]="!showNotifications" class="notification-menu" #menu>
    <div class="notification-empty" *ngIf="notifications.length === 0">
      <div class="icon">
          <app-svg-loader height="22px" url="assets/svg/bell-outline.svg"></app-svg-loader>
      </div>
      <div class="message">
        No Notifications
      </div>
    </div>
    <div class="notification-item" *ngFor="let n of notifications" (click)="onClickNotification(n)">
      <div class="message">{{n.message}}</div>
      <div class="time">{{ (n.createdAt?.toDate ? n.createdAt.toDate() : n.createdAt) | date:'short' }}</div>
    </div>
  </div>
</div>